import { Colors } from "Components/Layout/Themes/Colors";
import { Resources, useResource } from "Translations/Resources";
import { useEffect, type ReactNode } from "react";
import styled from "styled-components";

const StyledContent = styled.div`
  /* 100% of body, not 100vw — body enforces the minimum supported viewport
     width (see index.css) and vw units would ignore it */
  width: 100%;
  display: grid;
  background-color: ${Colors.BackgroundGrey};
`;

type Props = {
  title: string;
  children?: ReactNode;
};

export const UnauthenticatedLayout = ({ title, children }: Props) => {
  const { t } = useResource();

  useEffect(() => {
    document.title = `${title} | ${t(Resources.Common.AppName)}`;
  }, [title, t]);

  return (
    <StyledContent>
      <div>{children}</div>
    </StyledContent>
  );
};
